export type { SectionHeaderProps } from '~/components/section-header';
export { SectionHeader } from '~/components/section-header';
